import React from 'react';
import AssetTable from '../components/AssetTable';

export default function IndicesPage() {
  return <AssetTable type="index" title="Indizes" icon="fa-solid fa-chart-column" chartType="index" />;
}
